<div [class]="'w-full ' + customClass">
  @if (label) {
    <div class="flex items-center justify-between mb-1">
      <label [attr.for]="id || null" class="block text-sm font-medium text-stone-700">
        {{ label }}
      </label>
      <ng-content select="[label-suffix]"></ng-content>
    </div>
  }

  <div class="relative flex items-center w-full">
    @if (hasLeftIcon) {
      <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-stone-400">
        @if (icon === 'user') {
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        } @else if (icon === 'lock') {
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        } @else if (icon === 'email') {
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        } @else if (hasSearchIcon) {
          <app-icon-search color="currentColor" svgClass="w-4 h-4"></app-icon-search>
        }
      </div>
    }

    <input
      [attr.id]="id || null"
      [attr.name]="name || null"
      [type]="resolvedType"
      [value]="value"
      [placeholder]="placeholder"
      [attr.aria-label]="ariaLabel || label || null"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.autocomplete]="autocomplete"
      [class]="computedInputClasses"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown.enter)="onKeydownEnter($event)"
    />

    @if (isPassword) {
      <button
        type="button"
        class="absolute right-3 flex items-center text-stone-400 hover:text-primary focus:outline-none cursor-pointer"
        (click)="togglePasswordVisibility()"
      >
        @if (showPassword) {
          <app-icon-eye-off></app-icon-eye-off>
        } @else {
          <app-icon-eye></app-icon-eye>
        }
      </button>
    }
  </div>

  @if (reserveErrorSpace) {
    <div class="h-5 min-h-[1.25rem] flex items-center mt-2">
      @if (error) {
        <span class="inline-flex items-center gap-1 text-xs text-red-600 font-medium animate-fade-in">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ error }}</span>
        </span>
      }
    </div>
  } @else if (error) {
    <span class="inline-flex items-center gap-1 text-xs text-red-600 font-medium mt-1 animate-fade-in">
      <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{{ error }}</span>
    </span>
  }
</div>
